// Single-page app: render only in the browser, and let adapter-static emit just the index.html fallback.
export const ssr = false;
export const prerender = false;
